var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"nonzero"},[React.createElement("path",{"d":"M6.91 0H28v23.24c-3.1-3-5.75-7.21-11.08-2.55-.6.53-4.7-1.63-6.17-3.35-1.47-1.72-2.93-5.77-2.17-6.43C14 6.13 9.43 3.3 6.91 0z","fill":"none","key":0}),React.createElement("path",{"d":"M6.79 0c2.472 3.217 6.956 5.976 1.638 10.636-.746.644.697 4.621 2.13 6.269 1.432 1.647 5.465 3.783 6.054 3.266 5.23-4.543 7.85-.488 10.872 2.486v.975c-6.055 5.557-10.794 5.85-17.221.663a36.742 36.742 0 01-5.995-6.21C-1.237 10.87-.746 5.957 5.808 0h.981z","key":1}),React.createElement("path",{"d":"M5.91 0C-.77 6.11-1.27 11.15 4.34 18.52a37.58 37.58 0 006.11 6.37c6.53 5.29 11.38 5 17.55-.68V30H0V0h5.91z","fill":"none","key":2})]));
}

Phone.defaultProps = {"width":"28px","height":"30px","viewBox":"0 0 28 30"};

module.exports = Phone;

Phone.default = Phone;
